'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fixLineHeight = function fixLineHeight(lineHeight, displayName) {
  if (typeof lineHeight === 'string') {
    throw new Error('The element `' + displayName + '` has a `lineHeight` set with a String. Use numbers instead.');
  }

  return global.navigator && global.navigator.product === 'ReactNative' ? lineHeight : lineHeight + 'px';
};

var fixStyle = function fixStyle(style, displayName) {
  return _extends({}, style, {
    lineHeight: style.lineHeight ? fixLineHeight(style.lineHeight, displayName) : undefined
  });
};

exports.default = function (Target) {
  return (0, _recompose.setDisplayName)((0, _recompose.wrapDisplayName)(Target, 'normalizeStyle'))(function (_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    return _react2.default.createElement(Target, _extends({ style: style ? fixStyle(style, (0, _recompose.getDisplayName)(Target)) : undefined }, props));
  });
};